"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyNumberWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PolicyNumberWidget = /** @class */ (function (_super) {
    __extends(PolicyNumberWidget, _super);
    function PolicyNumberWidget(props) {
        return _super.call(this, props) || this;
    }
    PolicyNumberWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "policy-number mb-4", children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-light", children: "Policy no: " }), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: this.props.interaction.agreementNumber })] }));
    };
    return PolicyNumberWidget;
}(plugin_journey_1.WidgetBase));
exports.PolicyNumberWidget = PolicyNumberWidget;
//# sourceMappingURL=PolicyNumberWidget.js.map